import { Switch } from 'react-router-dom';
import BillPaymentPage from './BillPaymentPage';
import ProtectedRoute from '@/utils/ProtectedRoute';
import { usePermissions } from '@/providers/Permissions.provider';

const BillPaymentRoutes: React.FC = () => {
  const { permissions } = usePermissions();
  return (
    <Switch>
      <ProtectedRoute
        isAllowed={!!permissions.CreatePayments}
        showPermission
        exact
        path="/bill-payment"
        component={BillPaymentPage}
      />
    </Switch>
  );
};

export default BillPaymentRoutes;
